// extracted by mini-css-extract-plugin
module.exports = {"box":"_3FqmPke","column":"_1HsN9C9","row":"_1O9nRyo","box1":"_2VmHrtu","box2":"_2tbRLy7","box3":"_2ld3Mjq","box4":"_HeykQL0","box5":"_1COrSvD"};